import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Table } from "antd";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ValidationIcon, {
  getInputClassNamesUser,
  ErrorMessage,
} from "../../../global/components/ValidationIcon";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime"; 
import { Select} from "antd";
import CircleIIcon from "../../../assets/circle_i.svg";
import { updateUI } from "../../../store/actions/shipment";
import { useDispatch } from "react-redux";
import { Input } from "@vds/inputs";
import { Checkbox } from "@vds/checkboxes";
import ATSToolTip from "../../../global/components/ATSToolTip";
import { removeAccountPrefixFromLabels,getMinimum,getMaxAlert } from "../../../../src/global/utility/Utils";
import {MAX_CHAR_LIMITS,getCharLimitMsgIfExceeded} from "../../../global/constants/inputLimits";

export function ShipmentStepOne({profile}) {
  dayjs.extend(relativeTime);
  const isLoadingShipment = useSelector((state) => state.shipment.isLoading.shipments);
  const columns = [
    {
    title: (
        <>
        <span className="font-face-vzw">Profile Name</span>
        </>
    ),
      dataIndex: "devicemodel",
      key: "devicemodel",
      width: 150,
      onHeaderCell: () => ({
        "data-tooltip": "",
      }),
      render: (text) => {
        return (
      <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
        {text}
      </div>
    );
       //return text;
      },
    },
    {
    title: (<span className="font-face-vzw">Updated</span>),
      dataIndex: "updatedon",
      key: "updatedon",
      width: 100,
      onHeaderCell: () => ({
        "data-tooltip": "", 
      }),
      render: (text) => <span>{dayjs(text).fromNow()}</span>,
    },
    {
    title: (<span className="font-face-vzw">Created</span>),
      dataIndex: "createdon",
      className: "state",
      width: 150,
      render: (text) => <span>{dayjs(text).format("MM-DD-YY [at] hh:mm:ss a")}</span>,
      key: "createdon",
    },
    {
    title: (<span className="font-face-vzw">Created by</span>),
      dataIndex: "createdby",
      key: "createdby",
      width: 100,
      onHeaderCell: () => ({
        "data-tooltip": "",
      }),
      render: (text, record) => <span>{text}</span>,
    },
  ];

  return (
    <>
     <div className="py-3 shipment-clone-step2-container">
     <h6 className="model-inline-heading">Select device profile</h6>
     <br/>
      <Table
      loading={isLoadingShipment}
      style={{ tableLayout: "revert-layer" }}
        rowKey="shipment-row-key"
        columns={columns}
        dataSource={profile}
        pagination={false}
        scroll={{ y: 300 }}
      />
      </div>
      <br/>
    </>
  );
}





export function ShipmentStepTwo({shipmetProfile}) {
    const isLoadingShipment = useSelector((state) => state.shipment.isLoading.shipments);
    const selectedProfileId = useSelector((state) => state.shipment.ui.create.selectedProfileId); 
    function getDeviceDetails(devices) {
      let result = devices?.find(device => device?.profileid === selectedProfileId);
      if (result) {
          return {
              attributes: result?.attributes,
              locations: result?.locations,
              frequencies: result?.frequencies,
              profilename:result?.profilename,
          };
      }
  }
    var extractedDetails = getDeviceDetails(shipmetProfile);
    var frequencies = extractedDetails?.frequencies;
    let tableData = [];
    var value= extractedDetails?.attributes;
    {value?.map((item, index) => {
        tableData.push({ 
          name: `${item?.name} (${item?.unit})`, 
          minAlert: getMinimum(item?.name,item?.min),
          maxAlert: getMaxAlert(item),
          alertType: item?.alertType !== null  ? item.alertType.charAt(0).toUpperCase() + item.alertType.slice(1) : "None",
          alertGroup: Array.isArray(item?.alertGroup) && item?.alertGroup.length > 0
            ? removeAccountPrefixFromLabels(item?.alertGroup).join(", ")
            : "None",
          alert: item?.alert ? item?.alert?.charAt(0)?.toUpperCase() + item?.alert?.slice(1)?.toLowerCase() : "Platform alert"
        })
    })}
      const columns = [
  {
    title: (
      <span className="font-face-vzw" style={{ display: "flex", alignItems: "center" }}>
        Attribute
      </span>
    ),
    dataIndex: "name",
    key: "name",
    width: 50,
    render: (text) => (
      <div className="d-flex flex-row justify-content-start align-items-center">
        <div>{text}</div>
      </div>
    ),
  },
  {
    title: (
      <span className="font-face-vzw" style={{ display: "flex", alignItems: "center" }}>
        Alert 
        <ATSToolTip text="Alert trigger based on">
          <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
        </ATSToolTip>
      </span>
    ),
    dataIndex: "alert",
    key: "alert",
    width: 50,
  },
  {
    title: (
      <span className="font-face-vzw" style={{ display: "flex", alignItems: "center" }}>
        Min
        <ATSToolTip text="Minimum value">
          <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
        </ATSToolTip>
      </span>
    ),
    dataIndex: "minAlert",
    key: "minAlert",
    width: 45,
  },
  {
    title: (
      <span className="font-face-vzw" style={{ display: "flex", alignItems: "center" }}>
        Max
        <ATSToolTip text="Maximum value">
          <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
        </ATSToolTip>
      </span>
    ),
    dataIndex: "maxAlert",
    key: "maxAlert",
    width: 45,
  },
  {
    title: (
      <span className="font-face-vzw" style={{ display: "flex", alignItems: "center" }}>
        Alert Type
        <ATSToolTip text="Severity level of the alarm">
          <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
        </ATSToolTip>
      </span>
    ),
    dataIndex: "alertType",
    key: "alertType",
    width: 70,
  },
  {
    title: (
      <span className="font-face-vzw" style={{ display: "flex", alignItems: "center" }}>
        Alert Group
        <ATSToolTip text="Alert groups to be notified of the alarm">
          <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
        </ATSToolTip>
      </span>
    ),
    dataIndex: "alertGroup",
    key: "alertGroup",
    width: 80,
  },
];
    let tableLocationData = [];
    var value= extractedDetails?.locations
    {value?.map((item, index) => (
      tableLocationData.push({ 
        locationtype:item,
     // locationtype:item?.locationtype,
        name: item?.name,
        address: item?.address,
        trigger: item?.trigger,
      //  latitude: item?.latitude,
       // longitude: item?.longitude,
        radius: item?.radius,
        alerttype: item?.alerttype  ? item?.alerttype?.charAt(0)?.toUpperCase() + item?.alerttype?.slice(1) : "Notification",
        alertgroup: Array.isArray(item?.alertgroup) && item?.alertgroup.length > 0
          ? removeAccountPrefixFromLabels(item?.alertgroup).join(", ")
          : item?.alertgroup || "None",
      })
    ))
  }

    const locationcolumns = [
      {
      title: (<span className="font-face-vzw">Shipping</span>),
        dataIndex: "locationtype",
        key: "nalocationtypeme",
        width: 70,
        onHeaderCell: () => ({
          "data-tooltip": "",
        }),
        render: (text) => {
          return (
            <div className="d-flex flex-row justify-content-start align-items-center">
              <div>{text?.locationtype}<br/>({text?.name})</div>
            </div>
          );
        },
      },
      {
      title: (<span className="font-face-vzw">Address</span>),
        dataIndex: "address",
        key: "address",
        width: 170,
        onHeaderCell: () => ({
          "data-tooltip": "", 
        }),
        render: (text) => {
          return text;
        },
      },
      // {
      // title: (<span className="font-face-vzw">Latitude</span>),
      //   dataIndex: "latitude",
      //   className: "latitude",
      //   width: 70,
      //   render: (text) => <span className="table-inline-ship-text">{text}</span>,
      //   key: "latitude",
      // },
      // {
      // title: (<span className="font-face-vzw">Longitude</span>),
      //   dataIndex: "longitude",
      //   key: "longitude",
      //   width: 70,
      //   onHeaderCell: () => ({
      //     "data-tooltip": "",
      //   }),
      //   render: (text, record) => <span className="table-inline-ship-text">{text}</span>,
      // },
      // {
      //   title: (<span className="font-face-vzw">Name</span>),
      //     dataIndex: "name",
      //     key: "name",
      //     width: 70,
      //     onHeaderCell: () => ({
      //       "data-tooltip": "",
      //     }),
      //     render: (text, record) => <span>{text}</span>,
      //   },
        {
          title: (<span className="font-face-vzw" style={{ display: "flex", alignItems: "center"}}>
              Trigger
              <ATSToolTip text="Trigger alerts on">
                <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
              </ATSToolTip>
              </span>),
            dataIndex: "trigger",
            key: "trigger",
            width: 50,
            render: (text, record) => <span>{text !==undefined?text:"None"}</span>,
          },
           {
          title: (<span className="font-face-vzw" style={{ display: "flex", alignItems: "center"}}>Radius
           <ATSToolTip text="Geofench radius in meters">
          <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
         </ATSToolTip>
          </span>),
            dataIndex: "radius",
            key: "radius",
            width: 70,
            onHeaderCell: () => ({
              "data-tooltip": "",
            }),
            render: (text, record) => <span>{text!==""?text+"m":"None"}</span>,
          },
          {
        title: ( <span className="font-face-vzw" style={{ display: "flex", alignItems: "center"}}>
        AlertType
        <ATSToolTip text="Severity level of the alarm">
          <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
        </ATSToolTip>
      </span>),
          dataIndex: "alerttype",
          key: "alerttype",
          width: 50,
          render: (text, record) => <span>{text}</span>,
        },
         {
         title: ( <span className="font-face-vzw" style={{ display: "flex", alignItems: "center", width:"130px"}}>
        Alert Group
        <ATSToolTip text="Alert groups to be notified of the alarm">
          <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
        </ATSToolTip>
      </span>),
          dataIndex: "alertgroup",
          key: "alertgroup",
          width: 50,
          render: (text, record) => <span>{text !==undefined?text:"None"}</span>,
        },
    ]
    return (
      <>
       <div>
        <br/>
        <h6 className="model-inline-heading">{extractedDetails?.profilename}</h6>
        <h6 className="model-inline-two-heading" style={{fontFamily:"VerizonNHGDSBold"}} >
        Attributes
          </h6>
          <div style={{ maxHeight: "400px", overflowY: "auto", width: "100%" }}>
        <Table
        loading={isLoadingShipment}
          rowKey="shipment-row-key"
          columns={columns}
          dataSource={tableData}
          pagination={false}
          scroll={{ y: 300 }}
        />
       </div>
    </div>
    <div>
        <br/>
        <h6 className="model-inline-two-heading" style={{fontFamily:"VerizonNHGDSBold"}} >Location</h6>
          <div style={{ maxHeight: "400px", overflowY: "auto", width: "100%" }}>
        <Table
         className="custom-table-shipment custom-table-shipment-location"
         loading={isLoadingShipment}
          rowKey="shipment-row-key"
          columns={locationcolumns}
          dataSource={tableLocationData}
          pagination={false}
        />
        </div>
    </div>
    <div>
    <br />
    {/* <Grid2 container spacing={2} style={{width:"200%"}}>
      <Grid2 item xs={12}>
          <strong className="model-field-heading">Alert Group <img src={CircleIIcon} alt="info"/></strong>
          <p>15 minutes</p>
      </Grid2>
    </Grid2> */}
  </div>
  <hr className="divider" />
  <div className="MuiGrid2-root MuiGrid2-direction-xs-row MuiGrid2-grid-xs-12 MuiGrid2-grid-sm-12 MuiGrid2-grid-md-12 MuiGrid2-grid-lg-12" style={{width:"200%"}}>
    <h6 className="model-inline-two-heading" style={{fontFamily:"VerizonNHGDSBold"}} >Frequency</h6>
    <Grid2 container spacing={2}>
    <Grid2 item xs={12} sm={4}>
          <strong className="model-field-heading">Reporting Frequency</strong>
           <p>{frequencies?.capturesensorvalues}</p>
      </Grid2>
      <Grid2 item xs={12} sm={4}>
          <strong className="model-field-heading">Monitoring Frequency</strong>
           <p>{frequencies?.sensordatafrequency}</p>
      </Grid2>
    </Grid2>
  </div>
  </>
    );
  }


  export function ShipmentStepThree({shipmetProfile,setFormData,formData,errors,handleChange}) {
    const isLoadingShipment = useSelector((state) => state.shipment.isLoading.shipments);
    const shipments = useSelector((state) => state?.shipment?.data?.deviceType);
    const deviceName = useSelector((state) => state?.shipment?.data?.deviceName); 
    const bleProfile = useSelector((state) => state.shipment.ui.create.bleProfile); 
    const [selectedDevices, setSelectedDevices] = useState({});
    var shipmetProfileVal = shipmetProfile;

  const tableprofileData =deviceName?.devices; 
  const filteredDevices = tableprofileData;
  const dispatch = useDispatch()
    let tableData = [];
    var value= filteredDevices
  useEffect(() => {
    let initialDevices = {};
    let initialProfiles = {};
    formData?.ble?.forEach(item => {
        initialDevices[item.uid] = true;
        initialProfiles[item.uid] = item.deviceProfile;
    });
    setSelectedDevices(initialDevices);
    if(formData?.ble[0]?.deviceProfile ===""||formData?.ble[0]?.deviceProfile===undefined){
      dispatch(updateUI({
        key: "create",
        value: {
          bleProfile: "",
        },
      }))
    }
}, [formData]);
const handleCheckboxChange = (uid, devicemodel) => {
  setSelectedDevices(prev => {
      const updatedSelection = { ...prev, [uid]: !prev[uid] };
      if (!updatedSelection[uid]) {
          setFormData(prevFormData => ({
              ...prevFormData,
              ble: prevFormData.ble.filter(item => item.uid !== uid)
          }));
      } else {
          setFormData(prevFormData => ({
              ...prevFormData,
              ble: [...prevFormData.ble, { uid, devicemodel, deviceProfile: "" }]
          }));
      }
      return updatedSelection;
  });
};
const handleChange1 = (e, uid) => {
  const { name, value,id, serial } = e.target;
  if (name === "deviceProfile") {
    function getDeviceDetails(devices, deviceProfile) {
      let result = devices?.find(device => device?.profileid === deviceProfile);
      if (result) {
        return {
          attributes: result?.attributes,
          name:result?.name,
        };
      }
    }
    var deviceProfile = value;
    var extractedDetails = getDeviceDetails(shipmetProfileVal, deviceProfile);
    var attributes = extractedDetails?.attributes || [];
    setFormData(prev => {
      let updatedBle = prev.ble.map(item => 
        item.uid === uid ? { ...item, name: id, deviceProfile: value, attributes,serial:serial } : item
      );
      return { ...prev, ble: updatedBle };
    });
    let allAttributes = formData.ble.flatMap(item => getDeviceDetails(shipmetProfileVal, item.deviceProfile)?.attributes || []);
    dispatch(updateUI({
      key: "create",
      value: { bleProfile: allAttributes },
    }));
  }
};
    {value?.filter((item) => item?.kind === "ts.device.ble" && item?.customdata?.isAvailable===true).map((item, index) => (
      tableData.push({ 
          bledeviceid: (
          <li>
            <Checkbox
              selected={selectedDevices[item.uid] || false}
              id={`checkbox-${item.uid}`}
            //  inputId={`checkbox-${item.uid}`}
              name={`device-${item.uid}`}
              value={item.uid}
              onChange={() => handleCheckboxChange(item.uid, item.devicetype)}
            >
               {item?.minor ?? item?.serial}
            </Checkbox>
          </li>
          ),
          devicename: item?.name,
          devicemodel: item?.devicetype,
          deviceProfile: (
              <Select
              disabled={!selectedDevices[item.uid]}
              className={`selectboxstyle shipment-clone-fields ${
                selectedDevices[item.uid] && !formData.ble.find(i => i.uid === item.uid)?.deviceProfile
                  ? "selectbox-error"
                  : formData.ble.find(i => i.uid === item.uid)?.deviceProfile
                    ? "selectbox-success"
                    : ""
              }`}
              name="deviceProfile"
              placeholder="Select Device Profile"
              onChange={(value) => handleChange1({ target: { name: "deviceProfile",id:item?.name, value, serial:item?.serial} }, item.uid)}
              value={formData?.ble?.find(i => i.uid === item.uid)?.deviceProfile || ""}
              options={[
                  { value: "", label: "Select Device Profile" },
                  ...(shipmetProfileVal
                      ?.filter((profileItem) => item.devicetype === profileItem.devicetype && profileItem?.profiletype !=="nonshipment")
                      .map((profileItem) => ({
                          value: profileItem?.profileid,
                          label: profileItem.profilename,
                      })) || []),
              ]}
          />

          ),
      })
  ))}
  
    const columns = [
      {
      title: (<span className="font-face-vzw">BLE device ID</span>),
        dataIndex: "bledeviceid",
        key: "bledeviceid",
        width: 110,
        onHeaderCell: () => ({
          "data-tooltip": "",
        }),
        render: (text) => {
          return text;
        },
      },
      {
      title: (<span className="font-face-vzw">Device name</span>),
        dataIndex: "devicename",
        key: "devicename",
        width: 140,
        onHeaderCell: () => ({
          "data-tooltip": "", 
        }),
        render: (text) => {
          return text;
        },
      },
      {
      title: (<span className="font-face-vzw">Model</span>),
        dataIndex: "devicemodel",
        className: "devicemodel",
        width: 100,
        render: (text) => <span>{text}</span>,
        key: "devicemodel",
      },
      {
      title: (<span className="font-face-vzw">Device profile</span>),
        dataIndex: "deviceProfile",
        key: "deviceProfile",
        width: 150,
        onHeaderCell: () => ({
          "data-tooltip": "",
        }),
        render: (text) => {
          return text;
        },
      },
    ]
    let tableLocationData = [];
    let allAttributes = Array.isArray(bleProfile) ? bleProfile : [];
    allAttributes?.forEach((item) => {
      tableLocationData.push({
        name: `${item?.name} (${item?.unit})`, 
        minAlert: item?.min,
        maxAlert: item?.max,
        alertType: item?.alertType,
        alertGroup: item?.alertGroup,
      });
    });
    const locationcolumns = [
      {
      title: (<span className="font-face-vzw">Attribute</span>),
        dataIndex: "name",
        key: "name",
        onHeaderCell: () => ({
          "data-tooltip": "",
        }),
        render: (text) => {
          return text;
        },
      },
      {
      title: (<span className="font-face-vzw">Minimum</span>),
        dataIndex: "minAlert",
        key: "minAlert",
        onHeaderCell: () => ({
          "data-tooltip": "", 
        }),
        render: (text) => {
          return text;
        },
      },
      {
      title: (<span className="font-face-vzw">Maximum</span>),
        dataIndex: "maxAlert",
        className: "maxAlert",
        render: (text) => <span>{text}</span>,
        key: "maxAlert",
      },
      {
      title: (<span className="font-face-vzw">Alert Type <img src={CircleIIcon} alt="info"/></span>),
        dataIndex: "alertType",
        key: "alertType",
        onHeaderCell: () => ({
          "data-tooltip": "",
        }),
        render: (text, record) => <span>{text}</span>,
      },
        {
          title: (<span className="font-face-vzw">Alert Group <img src={CircleIIcon} alt="info"/></span>),
            dataIndex: "alertGroup",
            key: "alertGroup",
            onHeaderCell: () => ({
              "data-tooltip": "",
            }),
            render: (text, record) => <span>{text}</span>,
          },
    ]
    function getDeviceDetails(devices, deviceProfile) {
      let result = devices?.find(device => device?.profileid === deviceProfile);
      if (result) {
        return {
          attributes: result?.attributes || [],
          name: result?.profilename || "BLE Device Profile",
        };
      }
      return { attributes: [], name: "BLE Device Profile" };
    }   
    return (
        <>
        <br/>
        <h6 className="model-inline-heading">Select BLE devices</h6>
          <div style={{ maxHeight: "400px", overflowY: "auto", width: "100%" }}>
        <Table
        loading={isLoadingShipment}
          rowKey="shipment-row-key"
          columns={columns}
          dataSource={tableData}
          pagination={false}
          scroll={{ y: 400 }}
          tableLayout="fixed" 
          locale={{ emptyText: "None of the BLE's are available" }} 
        />
        </div>
        {bleProfile===""? <Grid2 item xs={12} sm={12} md={12} lg={12}>
                <div className="shipment-profile-info">
                Select a profile to show profile summary
             </div>
             </Grid2>: <div>
             <br/>
             <h6 className="model-inline-heading">BLE device profile</h6>
             <br/>
          <div style={{ maxHeight: "400px", overflowY: "auto", width: "100%" }}>
          {formData.ble
          .filter(device => device.deviceProfile) 
          .map((device, index) => {
            const extractedDetails = getDeviceDetails(shipmetProfileVal, device.deviceProfile);
            const attributes = extractedDetails?.attributes || [];

            let tableLocationData = attributes.map((item) => ({
              name: `${item?.name} (${item?.unit})`, 
              minAlert: item?.min,
              maxAlert: item?.max,
              alertType: item?.alertType,
              alertGroup: Array.isArray(item?.alertGroup) && item.alertGroup.length > 0
                        ? removeAccountPrefixFromLabels(item.alertGroup).join(", ")
                        : (item?.alertGroup ?? "").toString().trim().length > 0
                          ? removeAccountPrefixFromLabels([item.alertGroup]).join(", ")
                          : "None",
             // alertGroup: item?.alertGroup,
            }));

            return (
              <div key={device.uid}>
                <br />
                <h6 className="model-inline-heading">
                {extractedDetails?.name || "BLE Device Profile"}
                </h6>
                <br />
                <div style={{ maxHeight: "400px", overflowY: "auto", width: "100%" }}>
                  <Table
                    className="custom-table-shipment"
                    loading={isLoadingShipment}
                    rowKey={`shipment-row-key-${index}`}
                    columns={locationcolumns}
                    dataSource={tableLocationData}
                    pagination={false}
                  />
                </div>
              </div>
            );
          })}
        </div>
    </div>}
    <div>
  </div>
        </>
    );
  }








export function ShipmentStepFour({ formData, errors, handleChange }) {
  return (
    <>
      <h6 className="model-inline-heading">Additional details</h6>
      <Grid2
        container
        marginTop={1}
        marginBottom={2}
        spacing={1}
        columns={{ xs: 12 }}
      >
        <Grid2 item xs={12} sm={6} md={6} lg={6}>
          <div>
          <Input
            type="text"
            id="productid"
            name="productid"
            value={formData?.productid}
            onChange={(e) => handleChange(e)}
            error={false}
            required={false}
            label="Product ID"
            maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
            width="100%"
          />
          {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData?.productid)}
          </div>
        </Grid2>
        <Grid2 item xs={12} sm={6} md={6} lg={6}>
           <div>
          <Input
            type="text"
            id="productserialnumber"
            name="productserialnumber"
            value={formData?.productserialnumber}
            onChange={(e) => handleChange(e)}
            error={false}
            required={false}
            label="Product Serial Number"
            maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
            width="100%"
          />
           {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData?.productserialnumber)}
          </div>
        </Grid2>
        <Grid2 item xs={12} sm={6} md={6} lg={6}>
          <div>
          <Input
            type="text"
            id="trackingnumber"
            name="trackingnumber"
            value={formData?.trackingnumber}
            onChange={(e) => handleChange(e)}
            error={false}
            required={false}
            maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
            label="Tracking Number"
            width="100%"
          />
           {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData?.trackingnumber)}
           </div>
        </Grid2>
        <Grid2 item xs={12} sm={6} md={6} lg={6}>
          <div>
          <Input
            type="text"
            id="ordernumber"
            name="ordernumber"
            value={formData?.ordernumber}
            onChange={(e) => handleChange(e)}
            error={false}
            required={false}
            label="Order Number"
            maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
            width="100%"
          />
           {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData?.ordernumber)}
         </div>
        </Grid2>
        <Grid2 item xs={12} sm={6} md={6} lg={6}>
          <div>
          <Input
            type="text"
            id="customername"
            name="customername"
            value={formData?.customername}
            onChange={(e) => handleChange(e)}
            error={false}
            required={false}
            label="Customer Name"
            maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
            width="100%"
          />
           {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData?.customername)}
        </div>
        </Grid2>
        <Grid2 item xs={12} sm={6} md={6} lg={6}>
          <div>
          <Input
            type="text"
            id="ponumber"
            name="ponumber"
            value={formData?.ponumber}
            onChange={(e) => handleChange(e)}
            error={false}
            required={false}
            label="PO Number"
            maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
            width="100%"
          />
           {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData?.ponumber)}
         </div>
        </Grid2>
      </Grid2>
    </>
  );
}









  export function ShipmentStepFive({formData}) {
    return (
      <>
         <h6 style={{fontFamily:"VerizonNHGDSBold"}}>More information</h6>
        <Grid2
        item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            container
            marginTop={1}
            marginBottom={2}
            spacing={1}
            columns={{ xs: 12  }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <label htmlFor="productid" className="input-label-user">
                Product ID
                </label>
                <div className="input-container">
                  <input
                    type="text"
                    id="productid"
                    name="productid"
                    value={formData?.productid}
                    className="form-control login-form-control"
                    style={{ boxShadow: "none" }}
                  />
                </div>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <label htmlFor="productserialnumber" className="input-label-user">
                Product Serial Number
                </label>
                <div className="input-container">
                  <input
                    id="productserialnumber"
                    name="productserialnumber"
                    className="form-control login-form-control"
                    value={formData?.productserialnumber}
                    style={{ boxShadow: "none" }}
                  />
                </div>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <label htmlFor="trackingnumber" className="input-label-user">
                Tracking Number
                </label>
                <div className="input-container">
                  <input
                    id="trackingnumber"
                    name="trackingnumber"
                    value={formData?.trackingnumber}
                    className="form-control login-form-control"
                    style={{ boxShadow: "none" }}
                  />
                </div>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <label htmlFor="ordernumber" className="input-label-user">
                Order Number
                </label>
                <div className="input-container">
                  <input
                    id="ordernumber"
                    name="ordernumber"
                    value={formData?.ordernumber}
                    className="form-control login-form-control"
                    style={{ boxShadow: "none" }}
                  />
                </div>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <label htmlFor="customername" className="input-label-user">
                Customer Name
                </label>
                <div className="input-container">
                  <input
                    id="customername"
                    name="customername"
                    value={formData?.customername}
                    className="form-control login-form-control"
                    style={{ boxShadow: "none" }}
                  />
                </div>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <label htmlFor="ponumber" className="input-label-user">
                PO Number
                </label>
                <div className="input-container">
                  <input
                    id="ponumber"
                    name="ponumber"
                    value={formData?.ponumber}
                    className="form-control login-form-control"
                    style={{ boxShadow: "none" }}
                  />
                </div>
              </div>
            </Grid2>
          </Grid2>
        </>
    );
  }